import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "captcha-row" }
const _hoisted_2 = ["src"]

import { onMounted, reactive, ref } from 'vue'

import type { ElForm } from 'element-plus'
import { accountRules } from '@/views/login/config/account-config'
import localCache from '@/utils/cache'
import store from '@/store'
import { getMathCaptcha } from '@/api/admin/loginApi'
import { showErrorIfNeeded } from '@/utils/common-util'


export default /*@__PURE__*/_defineComponent({
  __name: 'login-account',
  setup(__props, { expose: __expose }) {

const ruleFormRef = ref<InstanceType<typeof ElForm>>()
const captchaImg = ref('')

const account = reactive({
  username: localCache.getCache('username') ?? '',
  password: localCache.getCache('password') ?? '',
  captchaId: '',
  captchaCode: ''
})

const rules = accountRules

const refreshCaptcha = async () => {
  try {
    const res: any = await getMathCaptcha()
    const data = res?.data || {}
    account.captchaId = data.captchaId || ''
    captchaImg.value = data.img || ''
    account.captchaCode = ''
  } catch (error: any) {
    captchaImg.value = ''
    account.captchaId = ''
    showErrorIfNeeded(error, '获取验证码失败')
  }
}

const loginAction = (isKeepPassword: boolean) => {
  ruleFormRef.value?.validate(async (valid) => {
    if (!valid) return
    if (isKeepPassword) {
      localCache.setCache('username', account.username)
      localCache.setCache('password', account.password)
    } else {
      localCache.deleteCache('username')
      localCache.deleteCache('password')
    }
    try {
      await store.dispatch('login/accountLoginAction', {
        username: account.username,
        password: account.password,
        captchaId: account.captchaId,
        captchaCode: account.captchaCode
      })
    } catch {
      await refreshCaptcha()
    }
  })
}

onMounted(() => {
  refreshCaptcha()
})

__expose({
  loginAction,
  refreshCaptcha
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "ruleFormRef",
    ref: ruleFormRef,
    style: {"max-width":"600px"},
    model: account,
    "status-icon": "",
    rules: _unref(rules),
    "label-width": "auto",
    class: "accountForm"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "账号",
        prop: "username"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: account.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((account.username) = $event)),
            type: "input",
            autocomplete: "off"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "密码",
        prop: "password"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: account.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((account.password) = $event)),
            type: "password",
            autocomplete: "off",
            "show-password": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "动态码",
        prop: "captchaCode"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_input, {
              modelValue: account.captchaCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((account.captchaCode) = $event)),
              placeholder: "请输入计算结果",
              autocomplete: "off"
            }, null, 8, ["modelValue"]),
            (captchaImg.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "captcha-img",
                  src: captchaImg.value,
                  title: "点击刷新",
                  alt: "验证码",
                  onClick: refreshCaptcha
                }, null, 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "captcha-img captcha-img--placeholder",
                  title: "点击刷新",
                  onClick: refreshCaptcha
                }, "加载中"))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})